import { useMemo } from "react";
import { object, ref, string } from "yup";
import { FormField } from "./types";
import { REGEXP } from "consts/validation";
import { BusinessActivityOption } from "./BusinessActivityOption";

const useValidationSchema = () =>
    useMemo(() => (
        object().shape({
            [FormField.BusinessActivity]: object()
                .nullable()
                .required()
                .label('Business Activity'),
            [FormField.Password]: string()
                .min(8)
                .matches(REGEXP.Uppercase, 'At least one uppercase letter (A-Z)')
                .matches(REGEXP.Lowercase, 'At least one lowercase letter (a-z)')
                .matches(REGEXP.Numbers, 'At least one number (0-9)')
                .matches(REGEXP.SpecialChars, 'At least one special character (e.g., !, @, #, $)')
                .required()
                .label('Password'),

            [FormField.ConfirmPassword]: string()
                .oneOf([ref(FormField.Password), null], 'Passwords don’t match. Try again')
                .required()
                .label('Confirm Password'),
            [FormField.Email]: string()
                .email()
                .required()
                .label('Email'),
            [FormField.ProductService]: object()
                .nullable()
                .required()
                .label('Product/Service'),

            [FormField.ProductServiceOther]: string()
                .when(FormField.ProductService, {
                    is: (val: any) =>
                        val?.id?.toString() === BusinessActivityOption.Other.toString(),
                    then: schema => schema.required('Please specify your product/service'),
                    otherwise: schema => schema.notRequired(),
                }),

        })
    ), []);

export default useValidationSchema;

